/**
 * Offsets en horas por device_id del checador.
 * Negativo = el dispositivo está adelantado → restamos para obtener hora real.
 *
 * checador_JJA1241400074: el device registra UTC+8 pero la ubicación es UTC-6
 * → diferencia de 14 horas que hay que restar.
 */
const DEVICE_OFFSET_HOURS = {
  "checador_JJA1241400074": -14,
};

/**
 * Aplica el offset de zona horaria del dispositivo a un event_datetime.
 *
 * @param {string} datetimeStr  Ej: "2026-06-10 03:07:00"
 * @param {string} deviceId     Ej: "checador_JJA1241400074"
 * @returns {string}            Datetime corregido: "2026-06-09 13:07:00"
 */
export function applyChecadorOffset(datetimeStr, deviceId) {
  const offsetHours = DEVICE_OFFSET_HOURS[deviceId] || 0;
  if (!offsetHours) return datetimeStr;

  const d = new Date(datetimeStr.replace(" ", "T"));
  d.setTime(d.getTime() + offsetHours * 60 * 60 * 1000);

  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}

/**
 * Retorna solo la parte de fecha corregida (YYYY-MM-DD) de una checada.
 *
 * @param {{ device_id: string, parsed: { event_datetime: string } }} checada
 * @returns {string}  Ej: "2026-06-09"
 */
export function getChecadaDateStr(checada) {
  const dt = checada?.parsed?.event_datetime;
  if (!dt) return "";
  return applyChecadorOffset(dt, checada.device_id).slice(0, 10);
}
